var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('collapsable-card',{attrs:{"title":_vm.$t('app.general.title.limits'),"icon":"$limits","draggable":true,"layout-path":"dashboard.printer-limits-card"}},[_c('printer-limits')],1)}
var staticRenderFns = []

export { render, staticRenderFns }